<template>
  <VueApexCharts :options="chartOptions" :series="series" />
</template>

<script setup>

import { defineProps, computed } from 'vue'
import VueApexCharts from 'vue3-apexcharts'

const props = defineProps({
  data: {
    type: Array,
    required: true,
  },
  title: {
    type: String,
    required: true,
    default: "No title",
  },
})

const ratings = Array(5).fill(0).map((_, index) => index + 1).reverse();

const countByRating = (rating) =>
  computed(() => props.data.filter((review) => review.rating === rating).length);

const series = computed(() => [
  {
    name: 'Reviews',
    data: ratings.map((rating) => ({
      x: rating.toString(),
      y: countByRating(rating).value,
    })),
  },
]);

const chartOptions = computed(() => ({

  chart: {
    type: 'bar',
    foreColor: 'white'
  },

  plotOptions: {
    bar: {
      borderRadius: 2,
      horizontal: true,
    }
  },

  title: {
    text: props.title,
  },

  dataLabels: {
    enabled: false,
  },

  xaxis: {
    title: {
      text: 'Number of Reviews',
    },
    tickAmount: 5,
  },

  yaxis: {
    title: {
      text: "Rating",
    },
  },

  tooltip: {
    theme: 'dark'
  },

}))

</script>
